import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
export default function ResolveSkuAtributes({ contentData, updateAttributeState }) {
  const query = useQuery();
  const sku = query.get('sku');

  useEffect(() => {
    const skuFound = contentData.skus?.find((item) => item.partnumber === sku);
    skuFound?.definingAttributes?.map((dAttr) => {
      let attrName = dAttr.name;
      let attrVal = dAttr.value.value;
      updateAttributeState(attrName, attrVal);
    });
  }, [sku, contentData, updateAttributeState]);

  return null;
}
